import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { useTranslation } from 'react-i18next';

type DiscardChangesModalProps = {
  open: boolean;
  fileName?: string;
  onCancel: () => void;
  onDiscard: () => void;
};

export function DiscardChangesModal({
  open,
  fileName,
  onCancel,
  onDiscard,
}: DiscardChangesModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader className="gap-3">
          <DialogTitle>{t('DISCARD_CHANGES') || 'Discard changes'}</DialogTitle>
          <DialogDescription className="text-pretty">
            {`${t('YOU_HAVE_UNSAVED_CHANGES_IN')} ${fileName}. ${t('DO_YOU_WANT_TO_DISCARD_THEM?')}`}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-row justify-end gap-2 sm:gap-2">
          <Button variant="outline" size="sm" onClick={onCancel}>
            {t('CANCEL') || 'Cancel'}
          </Button>
          <Button variant="destructive" size="sm" onClick={onDiscard}>
            {t('DISCARD') || 'Discard'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
